/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  ArrowRightOutlined,
  CalendarOutlined,
  ContainerOutlined,
  CopyOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  Loading3QuartersOutlined,
  LoadingOutlined,
  MoreOutlined,
  SendOutlined,
  SettingOutlined,
  StopOutlined,
  TableOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {
  Avatar,
  Breadcrumb,
  Button,
  Collapse,
  Divider,
  Dropdown,
  Empty,
  Form,
  message,
  Modal,
  Radio,
  Spin,
  Tabs,
  Tag,
  Tooltip,
} from 'antd';
import CycleSettings from 'components/cycleSettings';
import Header from 'components/header';
import RenameCycleModal from 'components/renameCycleModal';
import Sidebar from 'components/sidebar';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  exportReviews,
  getCycleDetails,
  getReviewById,
  listReviews,
  releaseAllReviews,
  releaseReview,
  releaseReviewee,
  toggleCycleArchived,
  updateCycle,
  updateCycleStatus,
} from 'services/api/cycles';
import styles from 'styles/cycleDetails.module.scss';
import {
  BLOCK_TYPES,
  CYCLE_STATUS,
  MODULES_ITEMS,
  QUESTIONS_TYPES,
  REVIEW_VISIBILITY,
} from 'utils/constants';
import CycleModules from 'components/cycleModules';
import dayjs from 'dayjs';
import CycleParticipants from 'components/cycleParticipants';
import { getTagFromStatus, injectQuestionNumbersToModule } from 'utils/utils';
import SendCycleModal from 'components/sendCycleModal';
import CyclesStatistics from 'components/cyclesStatistics';
import StopCycleModal from 'components/stopCycleModal';
import pluralize from 'pluralize';
import fileDownload from 'js-file-download';
import DuplicateCycleModal from 'components/duplicateCycleModal';

const ReviewItem = ({ review, cycle, fetchReviews }) => {
  const [releaseRevieweeLoading, setReleaseRevieweeLoading] = useState(false);
  const [releaseReviewType, setReleaseReviewType] = useState('just');
  const releaseRevieweeFunc = () => {
    setReleaseRevieweeLoading(true);
    releaseReviewee({
      cycleId: cycle._id,
      revieweeId: review.to._id,
    })
      .then((res) => {
        message.success('Reviews released successfully');
        fetchReviews();
      })
      .catch((err) => {
        console.error('err', err);
        message.error('Failed to release reviews');
      })
      .finally(() => {
        setReleaseRevieweeLoading(false);
      });
  };

  const releaseReviewFunc = () => {
    setReleaseRevieweeLoading(true);
    releaseReview({
      cycleId: cycle._id,
      reviewId: review._id,
    })
      .then((res) => {
        message.success('Review released successfully');
        fetchReviews();
      })
      .catch((err) => {
        console.error('err', err);
        message.error('Failed to release review');
      })
      .finally(() => {
        setReleaseRevieweeLoading(false);
      });
  };
  return (
    <div key={review._id} className={styles.reviewItem}>
      <div className={styles.reviewItemHeader}>
        <div className={styles.reviewItemModule}>
          <FileTextOutlined />
          &nbsp;
          {MODULES_ITEMS[review.moduleType].labelShort}
        </div>
        <div className={styles.reviewItemHeaderRight}>
          <div>
            <Avatar
              src={review.from.profile.profilePictureUrl}
              size={20}
              icon={<UserOutlined />}
            />
            &nbsp;{(review.from.profile.firstName || review.from.profile.lastName) ? `${review.from.profile.firstName} ${review.from.profile.lastName}` : review.from.email}
          </div>
          {review.moduleType !== MODULES_ITEMS.SELF.type && (
            <>
              <ArrowRightOutlined />
              <div>
                <Avatar
                  src={review.to.profile.profilePictureUrl}
                  size={20}
                  icon={<UserOutlined />}
                />
                &nbsp;
                {review.to.profile.firstName} {review.to.profile.lastName}
              </div>
            </>
          )}
        </div>
      </div>

      <div className={styles.reviewItemStatus}>
        {review.releasedAt &&
        cycle.reviewVisibility === REVIEW_VISIBILITY.MANAGER_RELEASE ? (
          <div>
            <Tag color="purple">
              <SendOutlined /> Released
              <Tooltip
                title={
                  <div>
                    Released on{' '}
                    {dayjs(review.releasedAt).format('DD/MM/YYYY HH:mm')}
                  </div>
                }
              >
                <CalendarOutlined />
              </Tooltip>
            </Tag>
          </div>
        ) : review.doneAt ? (
          <Tag color="green">
            Completed{' '}
            <Tooltip
              title={
                <div>
                  Completed on {dayjs(review.doneAt).format('DD/MM/YYYY HH:mm')}
                </div>
              }
            >
              <CalendarOutlined />
            </Tooltip>
          </Tag>
        ) : cycle.status === CYCLE_STATUS.LIVE ? (
          <Tag color="blue">Pending</Tag>
        ) : (
          <Tag color="grey">Not Sent</Tag>
        )}
      </div>
      {review.status === 'READY' && (
        <Dropdown
          trigger={['click']}
          menu={{
            items: [
              {
                label: (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      Modal.confirm({
                        title: 'Release reviews to employee',
                        okText: 'Yes, release',
                        okButtonProps: {
                          loading: releaseRevieweeLoading,
                          icon: <SendOutlined />,
                        },
                        width: 500,
                        cancelText: 'No, cancel',
                        content: (
                          <div>
                            Are you sure you want to release the reviews to the
                            employee?
                            <br />
                            Usually, managers release reviews to employees.
                            <div style={{ marginTop: 12 }}>
                              <div>
                                <Radio.Group
                                  onChange={(e) => {
                                    setReleaseReviewType(e.target.value);
                                  }}
                                  options={[
                                    {
                                      label: 'Just this review',
                                      value: 'just',
                                    },
                                    {
                                      label: (
                                        <span>
                                          All reviews for{' '}
                                          <b>{review.to.profile.firstName}</b>
                                        </span>
                                      ),
                                      value: 'all',
                                    },
                                  ]}
                                  value={releaseReviewType}
                                  vertical
                                />
                              </div>
                            </div>
                          </div>
                        ),
                        onOk: () => {
                          if (releaseReviewType === 'just') {
                            releaseReviewFunc();
                          } else {
                            releaseRevieweeFunc();
                          }
                        },
                      });
                    }}
                  >
                    Release reviews
                  </div>
                ),
                key: 'release',
                icon: <SendOutlined />,
                disabled: review.releasedAt,
              },
            ],
          }}
        >
          <Button
            size="small"
            type="link"
            icon={<MoreOutlined />}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          />
        </Dropdown>
      )}
    </div>
  );
};

const Cycle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [cycle, setCycle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [renameCycle, setRenameCycle] = useState(null);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [settingsForm] = Form.useForm();
  const [sendLoading, setSendLoading] = useState(false);
  const [sendCycleModalOpen, setSendCycleModalOpen] = useState(false);
  const [stopCycleModalOpen, setStopCycleModalOpen] = useState(false);
  const activeTab = searchParams.get('tab') || 'reviews';
  const [focusDeadline, setFocusDeadline] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [reviewsContent, setReviewsContent] = useState({});
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [reviewsDone, setReviewsDone] = useState([]);
  const [reviewsReady, setReviewsReady] = useState([]);
  const [otherReviews, setOtherReviews] = useState([]);
  const [getByidLoading, setGetByidLoading] = useState(null);
  const [activeKeysReviews, setActiveKeysReviews] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [duplicateModalVisible, setDuplicateModalVisible] = useState(false);
  const [duplicateLoading, setDuplicateLoading] = useState(false);
  const [releaseAllLoading, setReleaseAllLoading] = useState(false);

  const setActiveTab = (tab) => {
    setSearchParams({ tab });
  };

  useEffect(() => {
    if (searchParams.get('focusDeadline')) {
      setFocusDeadline(true);
    } else {
      setFocusDeadline(false);
    }
  }, [searchParams]);
  // 685bf5a966b230e3c997b1c4
  const fetchCycle = () => {
    if (!id || loading) {
      return;
    }
    setLoading(true);
    getCycleDetails(id)
      .then((res) => {
        const cycleWithModules = {
          ...res.data,
          modules: res.data.modules.map((m) =>
            injectQuestionNumbersToModule({
              ...m,
              label: MODULES_ITEMS[m.type].label,
              labelShort: MODULES_ITEMS[m.type].labelShort,
            })
          ),
        };

        setCycle(cycleWithModules);
        setSendCycleModalOpen(false);
      })
      .catch((e) => {
        console.error(e);
        message.error(
          'Error fetching cycle details, refresh the page to try again'
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const releaseAllReviewsFunc = () => {
    setReleaseAllLoading(true);
    releaseAllReviews({ cycleId: id })
      .then(() => {
        message.success('Reviews released successfully');
        fetchReviews();
      })
      .catch((err) => {
        console.error('err', err);
        message.error('Failed to release reviews');
      })
      .finally(() => {
        setReleaseAllLoading(false);
      });
  };

  const fetchReviews = () => {
    setReviewsLoading(true);
    listReviews({ cycleId: id })
      .then((res) => {
        setReviews(res.data);
        const reviewsDone = res.data?.filter((r) => r.status === 'DONE');
        const reviewsReady = res.data?.filter((r) => r.status === 'READY');
        const otherReviews = res.data?.filter(
          (r) => r.status !== 'DONE' && r.status !== 'READY'
        );
        setReviewsReady(reviewsReady);
        setReviewsDone(reviewsDone);
        setOtherReviews(otherReviews);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setReviewsLoading(false);
      });
  };

  const onRename = () => {
    setRenameCycle(cycle);
  };

  const onArchive = (cycle) => {
    return Modal.confirm({
      title: cycle.isArchived ? 'Unarchive Cycle' : 'Archive Cycle',
      content: `Are you sure you want to ${
        cycle.isArchived ? 'unarchive' : 'archive'
      } this cycle?`,
      onOk: () => {
        setArchiveLoading(true);
        toggleCycleArchived({ cycleId: cycle._id })
          .then(() => {
            fetchCycle();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            setArchiveLoading(false);
          });
      },
      okText: `Yes, ${cycle.isArchived ? 'Unarchive' : 'Archive'}`,
      cancelText: 'No, Cancel',
      okButtonProps: {
        loading: archiveLoading,
      },
    });
  };

  const onDuplicate = () => {
    if (!cycle) return;
    setDuplicateModalVisible(true);
  };

  const updateSettings = (vals) => {
    setUpdateLoading(true);
    updateCycle({
      cycleId: cycle._id,
      name: vals.cycleName,
      remindersTriggers: vals.remindersTriggers,
      remindersChannels:
        vals.remindersChannels === 'BOTH'
          ? ['EMAIL', 'SLACK']
          : [vals.remindersChannels],
      ...(vals.deadline
        ? { deadline: dayjs(vals.deadline).format('YYYY-MM-DD') }
        : {}),
      reviewVisibility: vals.reviewVisibility || 'IMMEDIATE',
    })
      .then(() => {
        fetchCycle();
        message.success('Cycle settings updated');
      })
      .catch((e) => {
        console.error(e);
        message.error('Error updating cycle settings');
      })
      .finally(() => {
        setUpdateLoading(false);
        setSearchParams((s) => {
          s.delete('focusDeadline');
          return s;
        });
      });
  };

  const saveCycleModules = (mods) => {
    const cleanMods = mods.map((m) => ({
      ...m,
      blocks: m.blocks.map((b) => ({
        ...b,
        _id: b._id.startsWith('GENERATED_') ? undefined : b._id,
      })),
    }));
    updateCycle({
      cycleId: cycle._id,
      modules: cleanMods,
    }).then(() => {
      fetchCycle();
    });
  };

  const updateCycleStatusFunction = (status) => {
    setSendLoading(true);
    updateCycleStatus({
      cycleId: cycle._id,
      status: status,
    })
      .then(() => {
        fetchCycle();
      })
      .catch((e) => {
        console.error(e);
        message.error('Error sending cycle');
      })
      .finally(() => {
        setSendLoading(false);
      });
  };

  const getReviewContent = (reviewId) => {
    setGetByidLoading(reviewId);
    getReviewById({ reviewId, cycleId: cycle._id })
      .then((res) => {
        setReviewsContent((r) => ({
          ...r,
          [reviewId]: res.data,
        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setGetByidLoading(null);
      });
  };

  const items = [
    {
      label: (
        <a
          onClick={cycle?.isArchived ? undefined : onRename}
          disabled={cycle?.isArchived}
        >
          <EditOutlined />
          &nbsp;Rename cycle
        </a>
      ),
      key: 'rename',
    },
    {
      label: (
        <a onClick={onDuplicate}>
          {duplicateLoading ? <Loading3QuartersOutlined /> : <CopyOutlined />}
          &nbsp;Duplicate cycle
        </a>
      ),
      key: 'duplicate',
    },
    {
      label: (
        <a onClick={() => onArchive(cycle)}>
          <ContainerOutlined />
          &nbsp;
          {cycle?.isArchived ? 'Unarchive cycle' : 'Archive cycle'}
        </a>
      ),
      key: 'archive',
    },
  ];

  useEffect(() => {
    fetchCycle();
  }, [id]);

  useEffect(() => {
    fetchReviews();
  }, [cycle]);

  const isLive = cycle?.status === 'LIVE' && dayjs(cycle.deadline) > dayjs() && !cycle.isArchived;
  const isLiveAndDeadlinePassed =
    cycle?.status === 'LIVE' && dayjs(cycle.deadline) < dayjs();
  const isAllReviewsCollected =
    isLive && cycle?.stats?.reviewsCount === cycle?.stats?.reviewsTotal;

  const ReviewContent = ({ review }) => {
    const module = cycle.modules.find((m) => m.type === review.moduleType);
    const questions = module.blocks.filter(
      (b) => b.type === BLOCK_TYPES.QUESTION.id
    );
    return (
      <div key={review._id}>
        <div>
          {questions.map((q, i) => {
            const answer = review.answers.find((a) => a.questionId === q._id);
            return (
              <div key={q._id} className={styles.reviewContentQuestion}>
                <div>
                  <b>
                    {i + 1}. {q.params.text}
                  </b>
                </div>
                <div>
                  {q.params.type === QUESTIONS_TYPES.RATING.id ? (
                    `${
                      q.params.choices.findIndex((c) => c === answer?.text) + 1
                    }. ${answer?.text}`
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: answer?.text.replace(/\n/g, '<br />'),
                      }}
                    ></div>
                  )}
                </div>
                {answer?.comment && (
                  <div>
                    <div style={{ fontWeight: 'bold' }}>Comment</div>
                    <div>{answer.comment}</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const ReviewCollapse = ({ reviewsCollapsed }) => (
    <Collapse
      activeKey={activeKeysReviews}
      onChange={(keys) => {
        setActiveKeysReviews(keys);
        for (const k of keys) {
          const r = reviews.find((r) => r.internalId === k);
          if (
            !reviewsContent[r._id] &&
            (r.status === 'DONE' || r.status === 'READY')
          ) {
            getReviewContent(r._id);
          }
        }
      }}
      items={reviewsCollapsed?.map((review) => ({
        key: review.internalId,
        label: (
          <ReviewItem
            review={review}
            cycle={cycle}
            fetchReviews={fetchReviews}
          />
        ),
        children: (
          <div key={review.internalId}>
            {reviewsContent[review._id] ? (
              <ReviewContent review={reviewsContent[review._id]} />
            ) : review.status === 'DONE' ||
              review.status === 'READY' ||
              getByidLoading === review._id ? (
              <div>
                <Loading3QuartersOutlined spin /> Loading...
              </div>
            ) : (
              <div style={{ color: 'grey' }}>Review not done yet</div>
            )}
          </div>
        ),
      }))}
      bordered={false}
    />
  );

  const exportAllReviews = () => {
    setExportLoading(true);
    return exportReviews(id)
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: 'application/zip' });
        fileDownload(pdfBlob, `${cycle.name}.zip`);
      })
      .catch((e) => {
        console.error(e);
        message.error("Couldn't export the reviews, please try again.");
      })
      .finally(() => {
        setExportLoading(false);
      });
  };

  return (
    <div>
      <Header />
      <div className={styles.dashboardWrapper}>
        <Sidebar />
        <div className={styles.content}>
          <div className={styles.inner}>
            <Breadcrumb
              items={[
                {
                  title: (
                    <a href="/#/cycles">
                      <HomeOutlined /> All Cycles
                    </a>
                  ),
                },
                {
                  title: cycle?.name,
                },
              ]}
            />
            <div className={styles.header}>
              <Spin
                spinning={loading}
                indicator={<LoadingOutlined spin style={{ fontSize: 44 }} />}
              >
                {cycle && (
                  <div className={styles.cycleDetails}>
                    <div className={styles.cycleDetailsHeader}>
                      <div className={styles.headerLeft}>
                        <h1>{cycle.name}</h1>
                        <div>
                          {getTagFromStatus(cycle)}

                          {isLiveAndDeadlinePassed && (
                            <Tag color="red">
                              Deadline passed&nbsp;
                              <Tooltip title="The deadline for this cycle has passed, users can still submit reviews.">
                                <InfoCircleOutlined />
                              </Tooltip>
                            </Tag>
                          )}
                          {cycle.isArchived && <Tag color="grey">Archived</Tag>}
                        </div>
                      </div>
                      <div className={styles.headerRight}>
                        {isLive && !isAllReviewsCollected && (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 4,
                            }}
                          >
                            <Tooltip
                              title={
                                <div>
                                  Deadline on{' '}
                                  {dayjs(cycle.deadline).format(
                                    'Do MMM YYYY HH:mm'
                                  )}
                                </div>
                              }
                            >
                              <div className={styles.cycleDeadline}>
                                {`${dayjs(cycle.deadline).diff(
                                  dayjs(),
                                  'days'
                                )} ${pluralize('day', dayjs(cycle.deadline).diff(dayjs(), 'day'))} remaining`}
                                &nbsp;
                                <InfoCircleOutlined />
                              </div>
                            </Tooltip>
                            <Divider type="vertical" />
                            <Button
                              type="link"
                              onClick={() => {
                                setSearchParams({
                                  tab: 'settings',
                                  focusDeadline: 'true',
                                });
                              }}
                              style={{ fontSize: 14, paddingLeft: 0 }}
                            >
                              Update deadline
                            </Button>
                          </div>
                        )}
                        {cycle.status === CYCLE_STATUS.DRAFT && (
                          <Tooltip
                            title={
                              cycle?.participants?.length === 0
                                ? 'Please add participants to send the cycle'
                                : cycle?.modules?.length === 0
                                ? 'Please add modules to send the cycle'
                                : cycle?.modules?.length === 0 &&
                                  cycle?.participants?.length === 0
                                ? 'Please add participants and modules to send the cycle'
                                : ''
                            }
                          >
                            <Button
                              disabled={
                                cycle?.participants?.length === 0 ||
                                cycle?.modules?.length === 0
                              }
                              type="primary"
                              loading={sendLoading}
                              icon={<SendOutlined />}
                              style={{ width: 160, marginRight: 12 }}
                              onClick={() => {
                                setSendCycleModalOpen(true);
                              }}
                            >
                              Send
                            </Button>
                          </Tooltip>
                        )}
                        {isLive && !isAllReviewsCollected && (
                          <Button
                            loading={sendLoading}
                            icon={<StopOutlined />}
                            style={{ marginRight: 12 }}
                            onClick={() => {
                              setStopCycleModalOpen(true);
                            }}
                          >
                            Stop / Pause cycle
                          </Button>
                        )}
                        {cycle.status === CYCLE_STATUS.SCHEDULED && (
                          <Button
                            loading={sendLoading}
                            icon={<StopOutlined />}
                            style={{ marginRight: 12 }}
                            onClick={() => {
                              Modal.confirm({
                                title: 'Cancel scheduled cycle',
                                content:
                                  'Are you sure you want to cancel the scheduled cycle and put it back in draft mode?',
                                onOk: () => {
                                  updateCycleStatusFunction(CYCLE_STATUS.DRAFT);
                                },
                                okText: 'Yes, Cancel Scheduling',
                                cancelText: 'No, Keep it scheduled',
                              });
                            }}
                          >
                            Cancel scheduling
                          </Button>
                        )}
                        <Dropdown menu={{ items }} trigger={['click']}>
                          <Button
                            icon={<MoreOutlined />}
                            ghost
                            type="secondary"
                          />
                        </Dropdown>
                      </div>
                    </div>
                    {isLive && <CyclesStatistics cycle={cycle} />}
                    <div className={styles.tabs}>
                      <Tabs
                        activeKey={activeTab}
                        onChange={(key) => setActiveTab(key)}
                        items={[
                          {
                            key: 'reviews',
                            label: (
                              <div>
                                <TableOutlined /> Reviews
                                {reviewsLoading ? (
                                  <LoadingOutlined spin />
                                ) : reviews?.length > 0 ? (
                                  ` (${reviewsDone.length + reviewsReady.length}/${reviews.length})`
                                ) : (
                                  ''
                                )}
                                {reviewsReady.length > 0 && (
                                  <Tooltip
                                    title={`${reviewsReady.length} ${pluralize(
                                      'review',
                                      reviewsReady.length
                                    )} ready but not yet released to ${pluralize(
                                      'employee',
                                      reviewsReady.length
                                    )}`}
                                  >
                                    <ExclamationCircleOutlined
                                      style={{
                                        color: '#faad14',
                                        marginLeft: 6,
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </div>
                            ),
                            children:
                              reviews?.length > 0 ? (
                                <div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    <Tooltip
                                      title={
                                        reviewsDone.length === 0
                                          ? 'No reviews completed yet.'
                                          : null
                                      }
                                    >
                                      <Button
                                        icon={<DownloadOutlined />}
                                        type="primary"
                                        ghost
                                        onClick={exportAllReviews}
                                        loading={exportLoading}
                                        disabled={reviewsDone.length === 0}
                                      >
                                        {`Download reviews completed${
                                          reviewsDone.length > 0
                                            ? ` (${reviewsDone.length})`
                                            : ''
                                        }`}
                                      </Button>
                                    </Tooltip>
                                  </div>
                                  {reviewsDone.length > 0 && (
                                    <div>
                                      <h2 style={{ marginBottom: 12 }}>
                                        {reviewsDone.length}{' '}
                                        {pluralize(
                                          'review',
                                          reviewsDone.length
                                        )}{' '}
                                        completed
                                      </h2>
                                    </div>
                                  )}
                                  <div style={{ marginBottom: 24 }}>
                                    <ReviewCollapse
                                      reviewsCollapsed={reviewsDone}
                                    />
                                  </div>

                                  {cycle.reviewVisibility ===
                                    REVIEW_VISIBILITY.MANAGER_RELEASE &&
                                    (reviewsReady.length > 0 ||
                                      cycle.status === CYCLE_STATUS.LIVE) && (
                                      <>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            marginBottom: 12,
                                            gap: 12,
                                          }}
                                        >
                                          <h2 style={{ margin: 0 }}>
                                            {reviewsReady.length}{' '}
                                            {pluralize(
                                              'review',
                                              reviewsReady.length
                                            )}{' '}
                                            ready to be released
                                          </h2>
                                          <Button
                                            type="primary"
                                            disabled={
                                              reviewsReady.length === 0
                                            }
                                            loading={releaseAllLoading}
                                            onClick={releaseAllReviewsFunc}
                                          >
                                            Release All
                                          </Button>
                                        </div>

                                        {reviewsReady.length > 0 ? (
                                          <div style={{ marginBottom: 24 }}>
                                            <ReviewCollapse
                                              reviewsCollapsed={reviewsReady}
                                            />
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              color: 'grey',
                                              marginBottom: 24,
                                            }}
                                          >
                                            All reviews are released
                                          </div>
                                        )}
                                      </>
                                    )}

                                  {otherReviews.length > 0 && (
                                    <div>
                                      <h2 style={{ marginBottom: 12 }}>
                                        {otherReviews.length}{' '}
                                        {pluralize(
                                          'review',
                                          reviewsDone.length
                                        )}{' '}
                                        to complete
                                      </h2>
                                    </div>
                                  )}
                                  <div>
                                    <ReviewCollapse
                                      reviewsCollapsed={otherReviews}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  <Empty
                                    description={
                                      <div>
                                        <div>
                                          No reviews to list yet. <br />
                                          Try adding participants and modules
                                        </div>
                                        <Button
                                          style={{ marginTop: 12 }}
                                          type="primary"
                                          onClick={() => {
                                            setActiveTab('participants');
                                          }}
                                        >
                                          Add participants
                                        </Button>
                                      </div>
                                    }
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                  />
                                </div>
                              ),
                          },
                          {
                            key: 'modules',
                            label: (
                              <div>
                                <TableOutlined /> Modules
                                {cycle.modules.length > 0 &&
                                  ` (${cycle.modules.length})`}
                              </div>
                            ),
                            children: (
                              <div>
                                <CycleModules
                                  disabled={
                                    cycle.status !== CYCLE_STATUS.DRAFT ||
                                    cycle.isArchived
                                  }
                                  modules={cycle.modules}
                                  setModules={(mods) => {
                                    setCycle((c) => ({ ...c, modules: mods }));
                                    saveCycleModules(mods);
                                  }}
                                />
                              </div>
                            ),
                          },
                          {
                            key: 'participants',
                            label: (
                              <div>
                                <UserOutlined /> Participants{' '}
                                {cycle.participants.length > 0 &&
                                  ` (${cycle.participants.length})`}
                              </div>
                            ),
                            children: (
                              <div>
                                <CycleParticipants
                                  cycle={cycle}
                                  fetchCycle={fetchCycle}
                                />
                              </div>
                            ),
                          },
                          {
                            key: 'settings',
                            label: (
                              <div>
                                <SettingOutlined /> Settings
                              </div>
                            ),
                            children: (
                              <div style={{ width: 500, maxWidth: '100%' }}>
                                <CycleSettings
                                  disabled={cycle.status !== CYCLE_STATUS.DRAFT}
                                  formRef={settingsForm}
                                  onFinish={updateSettings}
                                  cycle={cycle}
                                  focusDeadline={focusDeadline}
                                />
                                <div className={styles.actions}>
                                  <Button
                                    type="primary"
                                    loading={updateLoading}
                                    onClick={() => {
                                      settingsForm.submit();
                                    }}
                                    block
                                  >
                                    Save
                                  </Button>
                                </div>
                              </div>
                            ),
                          },
                        ]}
                      />
                    </div>
                  </div>
                )}
              </Spin>
            </div>
          </div>
        </div>
      </div>
      <RenameCycleModal
        cycle={renameCycle}
        open={!!renameCycle}
        onClose={() => {
          setRenameCycle(null);
          fetchCycle();
        }}
      />
      <DuplicateCycleModal
        open={duplicateModalVisible}
        cycle={cycle}
        onClose={() => setDuplicateModalVisible(false)}
        onDuplicated={(newCycle) => {
          setDuplicateModalVisible(false);
          navigate(`/cycles/${newCycle._id}`);
        }}
        onLoadingChange={(loading) => setDuplicateLoading(loading)}
      />
      <SendCycleModal
        cycle={cycle}
        open={sendCycleModalOpen}
        onClose={() => {
          setSendCycleModalOpen(false);
        }}
        onFinish={() => {
          fetchCycle();
        }}
      />
      <StopCycleModal
        cycle={cycle}
        open={stopCycleModalOpen}
        onClose={() => {
          setStopCycleModalOpen(false);
        }}
        onFinish={() => {
          fetchCycle();
          setStopCycleModalOpen(false);
        }}
      />
    </div>
  );
};

export default Cycle;
